
export const Modes = {global: 0, country: 1, state: 2, region: 3, city: 4, consent: 5, organisation:6};
export const ModeNames = {global: "World", country: "Country", state: "Island", region: "Region", consent: "Consent", organisation: "Company"};

export interface IView {
    center?: Array<Number>;
    zoom?: Number;
    bearing?: Number;
    pitch?: Number;
}

export interface IModeData {
    id: string;
    idISO?: string;
    label: string;
    view?: IView;
    bounds?: any;
    logo?: string;
    url?: string;
}




export var world: IModeData = {id: "wl", idISO: "WL", label: "World", view: {center: [ 34,  18], zoom: 1.31,
    "bearing": 0,
    "pitch": 0}};
export var newZealand: IModeData = {id: "nz", idISO: "NZ", label: "New Zealand", view: {center: [ 174.43680191045166,  -41.72028430282303], zoom: 5.15,
    "bearing": 0,
    "pitch": 0}};
export var northIsland: IModeData = {id: "north-island", label: "North Island", view: { center: [ 177.31755990128397, -38.55798123050432],   zoom: 6.2,
    "bearing": 0,
    "pitch": 0}};
export var southIsland: IModeData =  {id: "south-island", label: "South Island", view: {center: [ 171.64816858936888, -44.13465235254245], zoom: 6.2,
    "bearing": 0,
    "pitch": 0}}
export var marlborough: IModeData = {id: "Marlborough", idISO: "NZ-MBH", label: "Marlborough",  view: {center: [174.28753672331646, -41.401196859559015], zoom: 8.3,
        "bearing": 0,
        "pitch": 0},
        url: "www.marlborough.govt.nz",
};
       
export var gisborne: IModeData = {id: "Gisborne",  idISO: "NZ-GIS", label: "Gisborne",  view: {center: [178.2920978040803,  -38.19041852264656] ,  zoom: 8.4,
    "bearing": 0,
    "pitch": 0}, bounds: null, logo: "/images/gisborne-logo.jpg",
};

export var tasman: IModeData = {id: "NZ-TAS",  idISO: "NZ-TAS", label: "Tasman", bounds: null
  };
  export var canterbury: IModeData = {id: "NZ-CAN",  idISO: "NZ-CAN", label: "Canterbury", bounds: null};
export var nelson: IModeData = {id: "NZ-NSN",  idISO: "NZ-NSN", label: "Nelson", bounds: null};
export var otago: IModeData = {id: "NZ-OTA",  idISO: "NZ-OTA", label: "Otago", bounds: null};

export const RegionsByISO: Record<string, IModeData> = {
    "NZ": newZealand,
    "NZ-MBH": marlborough,
    "NZ-GIS": gisborne,
    "NZ-TAS": tasman,
    "NZ-NSN": nelson,
    "NZ-CAN": canterbury,
    "NZ-OTA": otago
}
export const RegionsByName: Record<string, IModeData> = {
    "marlborough": marlborough,
    "gisborne": gisborne,
    "tasman": tasman,
    "nelson": nelson,
    "otago": otago
};
export const StatesByRegion: Record<string, IModeData> = {
    "NZ-MBH": southIsland,
    "NZ-GIS": northIsland,
    "NZ-NSN": southIsland,
    "NZ-TAS": southIsland,
    "NZ-CAN": southIsland,
    "NZ-OTA": southIsland,
};
export const regions = [{id:"marlborough", name: "Marlborough" }, {id:"gisborne", name: "Gisborne" }, {id:"tasman", name: "Tasman"} ];

export const States  = {
    northIsland:  northIsland,
    southIsland:  southIsland
}
export function regionFromName(name: string):IModeData | undefined   {

    const nameLower = name.toLowerCase();
    return RegionsByName[nameLower];
}



